export default __webpack_public_path__ + "static/media/Group 879@2x.bcb8dc26.jpg";